import { useState, useEffect, CSSProperties } from 'react';

export function useAnimatedUnmount(
  isMounted: boolean,
  delayTime: number,
  mountedStyle: CSSProperties,
  unmountedStyle: CSSProperties,
) {
  const [style, setStyle] = useState(isMounted ? mountedStyle : unmountedStyle);
  const [showComponent, setShowComponent] = useState(isMounted);

  useEffect(() => {
    let timeoutId: number | undefined;
    if (isMounted) {
      setShowComponent(true);
      timeoutId = window.setTimeout(() => setStyle(mountedStyle), 10);
    } else {
      timeoutId = window.setTimeout(() => setShowComponent(false), delayTime);
      setStyle(unmountedStyle);
    }
    return () => clearTimeout(timeoutId);
  }, [isMounted, delayTime, mountedStyle, unmountedStyle]);
  return { showComponent, style };
}
